import React from "react";
import BodyTemplate from "../BodyTemplate";
import Heading from "../BodyTemplate/Heading";
import {
  ConditionBox,
  ConditionItem,
  ConditionTitle,
  ImageBox,
  ImageHolder,
  SelectedIcon,
} from "./healthConditionStyle";

function HealthConditions({
  data = {},
  width,
  activeCondition,
  onHealthConditionChange = () => {},
}) {
  const { conditions } = data;
  return (
    <BodyTemplate
      isBelowHeroSection
      width={width}
      p={width > 1079 ? "38px 40px 24px" : "22px 0px 14px"}
    >
      <Heading data={data} />
      {conditions?.length > 0 && (
        <ConditionBox>
          {conditions?.map((condition, index) => (
            <ConditionItem
              key={index}
              onClick={() => {
                if (activeCondition?.id !== index) {
                  onHealthConditionChange(condition, index);
                }
              }}
              isActive={activeCondition?.id === index}
            >
              {activeCondition?.id === index && (
                <SelectedIcon icon="icon-plan-check-circle" />
              )}
              <ImageBox>
                {condition.thumbnail && (
                  <ImageHolder src={condition.thumbnail} />
                )}
              </ImageBox>
              <ConditionTitle variant={width > 1079 ? "label1" : "label2"}>
                {condition.title}
              </ConditionTitle>
            </ConditionItem>
          ))}
        </ConditionBox>
      )}
    </BodyTemplate>
  );
}

export default HealthConditions;
